var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { html } from "lit";
import { property } from "lit/decorators.js";
import { OmniElement } from "../../omni-element.js";
import { css } from "lit";
const styles = css`:host{display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%}svg{width:6.7857142857rem;animation:loading-spinner .8196721311s linear infinite}slot{font-family:"Open Sans",sans-serif;font-size:9pt;color:#252a37}@keyframes loading-spinner{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`;
class OmniLoadingIndicator extends OmniElement {
  constructor() {
    super(...arguments);
    this.color = "#10a1d2";
    this.altText = "Loading spinner graphic";
  }
  static get styles() {
    return [...super.styles, styles];
  }
  render() {
    return html`
      <omni-style>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style="margin:auto;background:0 0"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
          display="block"
          part="svg">
          <title>${this.altText}</title>
          <circle
            cx="50"
            cy="50"
            r="32"
            stroke-width="6"
            stroke="${this.color}"
            stroke-dasharray="50.26548245743669 50.26548245743669"
            fill="none"
            stroke-linecap="round"
            transform="rotate(128.654 50 50)"></circle>
        </svg>
        <slot part="info"></slot>
      </omni-style>
    `;
  }
}
__decorateClass([
  property({ type: String })
], OmniLoadingIndicator.prototype, "color", 2);
__decorateClass([
  property({ type: String })
], OmniLoadingIndicator.prototype, "altText", 2);
OmniElement.register("omni-loading-indicator", OmniLoadingIndicator);
export {
  OmniLoadingIndicator
};
//# sourceMappingURL=omni-loading-indicator.js.map
